import { makeAuthorBasedVerification } from './makeVerification';

export const verifyEdit = makeAuthorBasedVerification(
  'edit_account_team_capacities',
  'edit_account_team_capacities_other'
);
